import { render, staticRenderFns } from "./BackupWizard.vue?vue&type=template&id=2238d8e1"
import script from "./BackupWizard.vue?vue&type=script&lang=js"
export * from "./BackupWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports